import { Component, Inject, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StorageService } from '@shared/services';
import { TranslateService } from '@shared/services/translate';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Md5 } from 'ts-md5/dist/md5';
import { Router } from '@angular/router';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/list';

import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
    selector: 'shopbox-staff-switcher',
    templateUrl: './staff-switcher.component.html',
    styleUrls: ['./staff-switcher.component.scss'],
    imports: [MatCard, MatRipple, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatButton, MatDivider, FormsModule, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIcon, MatSuffix, MatError, MatIconButton, TranslatePipe]
})
export class StaffSwitcherComponent {
  currentProfile: any;
  staff: any[] = [];
  recentStaff: any[] = [];
  result: any;
  icon: string = 'visibility';
  type: string = 'password';
  pinCodeCtrl: UntypedFormControl = new UntypedFormControl();

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.selectProfile(this.currentProfile.uid);
  }

  constructor(
    private _storage: StorageService,
    private _dialogRef: MatDialogRef<StaffSwitcherComponent>,
    private _changeDetectRef: ChangeDetectorRef,
    private _router: Router,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) {
    this.currentProfile = this._storage.getAccount();
    this.staff = data;
    this.pinCodeCtrl.valueChanges.subscribe((res) => {
      if (this.pinCodeCtrl.invalid) {
        this.pinCodeCtrl.setErrors({});
        this.pinCodeCtrl.updateValueAndValidity();
      }
    });
    this.getRecentStaff();
  }

  hide(save?: boolean) {
    this._dialogRef.close(save ? this.result : null);
  }

  selectProfile(uid: number) {
    const selectedStaff = this.staff.filter(element => element.uid === uid)[0];
    this.result = {
      result: true,
      staff: selectedStaff,
      pinCode: this.pinCodeCtrl.value
    };
    this.hide(true);
  }

  getRecentStaff() {
    this.recentStaff = this.staff.filter(element => element.recent && (element.account0.uid !== this.currentProfile.uid) && element['user_code']);
  }

  toggleVisiblity(event: MouseEvent) {
    event.stopPropagation();
    this.type = this.type === 'text' ? 'password' : 'text';
    this.icon = this.icon === 'visibility' ? 'visibility_off': 'visibility';
  }

  findCode() {
    const hashMd5: Md5 = new Md5();
    const hashCode =  Md5.hashStr(this.pinCodeCtrl.value);
    this.pinCodeCtrl.disable();
    hashMd5.end();
    const index = this.staff.findIndex(element => element.code === hashCode);
    if (index !== -1) {
      this.result = {
        result: true,
        staff: this.staff[index],
        pinCode: this.pinCodeCtrl.value
      };
      this.hide(true);
    } else {
      this.pinCodeCtrl.enable();
      this.pinCodeCtrl.updateValueAndValidity();
      this.pinCodeCtrl.setErrors({notExist: true});
      this._changeDetectRef.markForCheck();
    }
  }

  goToSettings() {
    this.hide();
    this._router.navigateByUrl('/account-settings/general');
  }

}
